import { IAction, IThunkAction, IDispatch } from '../actions/createActionCreator';
import { IMiddleware } from './IMiddleware';
import { IStore } from '../createStore';
import { now } from '../../utilities/performance';

/**
 * all: log all action dispatches including thuck actions
 * origin: log vanilla redux action dispatches
 */
const enum LoggingLevel {
  all = 'all',
  origin = 'origin',
  none = 'none'
}

function getLoggingLevel(): LoggingLevel {
  try {
    if ('sessionStorage' in window) {
      // tslint:disable:no-string-literal
      const flag = window.sessionStorage['itemCacheLogging'];
      // tslint:enable:no-string-literal
      if (flag) {
        switch (flag.toLowerCase()) {
          case LoggingLevel.all:
            return LoggingLevel.all;
          case LoggingLevel.origin:
            return LoggingLevel.origin;
          case LoggingLevel.none:
          default:
            return LoggingLevel.none;
        }
      }
    }
  } catch (e) {
    // sessionStorage errors
  }
  return LoggingLevel.none;
}
const loggingLevel = getLoggingLevel();

function loggingFunc<S, A>(
  currentState: S,
  action: A,
  newState: S
): void {
  if (typeof console !== 'undefined') {
    console.log(
      now(),
      ' current state: ',
      currentState,
      ' dispatching action: ',
      action,
      ' new state: ',
      newState);
  }
}

export const loggingMiddleware: IMiddleware = <S>({ dispatch, getState }: Pick<IStore<S>, 'dispatch' | 'getState'>) => {
  return (next: IDispatch<S>) => {
    return <R>(action: IAction | IThunkAction<R, S, {}>) => {
      const isThunkAction = typeof action === 'function';
      let currentState, newState, result;
      switch (loggingLevel) {
        case LoggingLevel.origin:
          if (!isThunkAction) {
            currentState = getState();
          }
          result = next(action as IAction);
          if (!isThunkAction) {
            newState = getState();
            loggingFunc(currentState, action, newState);
          }
          break;
        case LoggingLevel.all:
          currentState = getState();
          result = next(action as IAction);
          newState = getState();
          loggingFunc(currentState, action, newState);
          break;
        case LoggingLevel.none:
        default:
          result = next(action as IAction);
      }
      return result;
    };
  };
};